import { type Common } from '../common.js';
import {
  type CaseStudyImageUploadRequest,
  type CaseStudyImageUploadResponse,
  type CreateValues,
  type FindAllOptions,
  type FlowDefinitionTemplate,
  type ThumbnailUploadRequest,
  type ThumbnailUploadResponse,
  type UpdateValues,
  findAllOptionsSchema,
} from '../models/flow/flowDefinitionTemplate.js';

export class API {
  common: Common;
  baseEndpoint = '/flow/flow-definition-templates';

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(rawQueryParams?: FindAllOptions): Promise<FlowDefinitionTemplate[]> {
    const queryParams = findAllOptionsSchema.parse(rawQueryParams);
    const url = this.common.constructPath(this.baseEndpoint, queryParams);
    return await this.common.getJSON(url);
  }

  async create(values: CreateValues): Promise<FlowDefinitionTemplate> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.postJSON(url, values);
  }

  async update(id: string, values: UpdateValues): Promise<FlowDefinitionTemplate> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.patchJSON(url, values);
  }

  async findOneById(flowDefinitionTemplateId: string): Promise<FlowDefinitionTemplate> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${flowDefinitionTemplateId}`);
    return await this.common.getJSON(url);
  }

  async delete(flowDefinitionTemplateId: string): Promise<FlowDefinitionTemplate> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${flowDefinitionTemplateId}`);
    return await this.common.deleteJSON(url);
  }

  async uploadThumbnail(
    flowDefinitionTemplateId: string,
    body: ThumbnailUploadRequest
  ): Promise<ThumbnailUploadResponse> {
    const url = this.common.constructPath(
      `${this.baseEndpoint}/${flowDefinitionTemplateId}/thumbnail`
    );
    return await this.common.postJSON(url, body);
  }

  async uploadCaseStudyImage(
    flowDefinitionTemplateId: string,
    body: CaseStudyImageUploadRequest
  ): Promise<CaseStudyImageUploadResponse> {
    const url = this.common.constructPath(
      `${this.baseEndpoint}/${flowDefinitionTemplateId}/case-study-image`
    );
    return await this.common.postJSON(url, body);
  }
}
